var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        attrs: {
          title: "Resumen del Documento",
          breadcrumbs: _vm.breadcrumbs,
          breadcrumbsItemDinamic: {
            loading: _vm.loadingDetail,
            text: `${_vm.activeDocument?.name} Nº ${_vm.instance.number}`,
          },
          dense: true,
          hiddenTab: true,
          addPadding: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c(
                  "v-btn",
                  {
                    staticClass: "mr-2",
                    attrs: { outlined: "" },
                    on: { click: _vm.retrieve },
                  },
                  [
                    _c("v-img", {
                      attrs: {
                        contain: "",
                        src: require(`@/assets/icon-update${
                          _vm.$vuetify.theme.dark ? "-dark" : ""
                        }.svg`),
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "v-menu",
                  {
                    attrs: {
                      "close-on-click": "",
                      "close-on-content-click": "",
                      "offset-y": "",
                      left: "",
                      "nudge-bottom": 10,
                      transition: "slide-y-transition",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "mr-2",
                                    attrs: { outlined: "" },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c("v-icon", { attrs: { left: "" } }, [
                                  _vm._v("mdi-plus-box "),
                                ]),
                                _vm._v("Opciones"),
                                _c(
                                  "v-icon",
                                  { attrs: { size: "18", right: "" } },
                                  [_vm._v("mdi-chevron-down")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _c(
                      "v-list",
                      { staticClass: "pa-0" },
                      [
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                return _vm.downloadFile2(
                                  "documents",
                                  `${_vm.instance.type}_${_vm.instance.number}`
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              {
                                staticClass:
                                  "d-flex align-center body-1 grey-500--text",
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: "grey-700",
                                      size: "20",
                                      left: "",
                                    },
                                  },
                                  [_vm._v("mdi-code-braces-box")]
                                ),
                                _vm._v("Descargar documento"),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        ["APR", "OBS"].includes(_vm.instance.status) &&
                        _vm.$store?.state?.auth?.account?.country === "PE"
                          ? _c(
                              "v-list-item",
                              {
                                staticClass: "px-3",
                                attrs: { ripple: false },
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadFile2(
                                      "documents",
                                      `${_vm.instance.type}_${_vm.instance.number}`,
                                      null,
                                      "voucher"
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-title",
                                  {
                                    staticClass:
                                      "d-flex align-center body-1 grey-500--text",
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color: "grey-700",
                                          size: "20",
                                          left: "",
                                        },
                                      },
                                      [_vm._v("mdi-code-braces-box")]
                                    ),
                                    _vm._v("Descargar CDR"),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.instance.assignment_agency_status
                          ? _c(
                              "v-list-item",
                              {
                                staticClass: "px-3",
                                attrs: { ripple: false },
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadFile2(
                                      "documents",
                                      `${_vm.instance.type}_${_vm.instance.number}_AEC`,
                                      null,
                                      "aec"
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-title",
                                  {
                                    staticClass:
                                      "d-flex align-center body-1 grey-500--text",
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color: "grey-700",
                                          size: "20",
                                          left: "",
                                        },
                                      },
                                      [_vm._v("mdi-code-braces-box")]
                                    ),
                                    _vm._v("Descargar AEC"),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.$store?.state?.auth?.account?.country === "CL" &&
                        _vm.instance.type === "CL52" &&
                        ["APR", "OBS"].includes(_vm.instance.status) &&
                        _vm.$helpers.hasPermission(["void_document"])
                          ? _c(
                              "v-list-item",
                              {
                                staticClass: "px-3",
                                attrs: { ripple: false },
                                on: {
                                  click: function ($event) {
                                    _vm.dialogMarkAsAnulled = true
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-title",
                                  {
                                    staticClass:
                                      "d-flex align-center body-1 grey-500--text",
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color: "grey-700",
                                          size: "20",
                                          left: "",
                                        },
                                      },
                                      [_vm._v("mdi-file-cancel-outline")]
                                    ),
                                    _vm._v("Marcar como nulo"),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        !["VOI", "INV", "APR", "OBS"].includes(
                          _vm.instance.status
                        )
                          ? _c(
                              "v-list-item",
                              {
                                staticClass: "px-3",
                                attrs: { ripple: false },
                                on: {
                                  click: function ($event) {
                                    _vm.dialogReprocessDoc = true
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-title",
                                  { staticClass: "body-1 grey-500--text" },
                                  [_vm._v("Re-procesar el documento")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-list-item",
                          {
                            staticClass: "px-3",
                            attrs: { ripple: false },
                            on: {
                              click: function ($event) {
                                _vm.modalEmail = true
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-title",
                              {
                                staticClass:
                                  "d-flex align-center body-1 grey-500--text",
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: "grey-700",
                                      size: "20",
                                      left: "",
                                    },
                                  },
                                  [_vm._v("mdi-email")]
                                ),
                                _vm._v("Enviar por mail"),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-btn",
                  {
                    attrs: { outlined: "" },
                    on: {
                      click: function ($event) {
                        _vm.modalPDF = true
                      },
                    },
                  },
                  [
                    _c("v-icon", { attrs: { left: "" } }, [
                      _vm._v("mdi-text-box"),
                    ]),
                    _vm._v("Ver PDF"),
                  ],
                  1
                ),
                ["APR", "OBS"].includes(_vm.instance.status) &&
                ["REJ", null, "ERR", "VOI", "UNK"].includes(
                  _vm.instance.assignment_agency_status
                ) &&
                _vm.$store?.state?.auth?.account?.country === "CL" &&
                ["CL33", "CL34", "CL43"].includes(_vm.instance.type) &&
                _vm.$helpers.hasPermission(["add_grant"])
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "ml-2",
                        attrs: { outlined: "" },
                        on: {
                          click: function ($event) {
                            _vm.dialogGrant = true
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("mdi-file"),
                        ]),
                        _vm._v("Ceder documento "),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.$store.state.auth.account.country !== "PE" &&
                !_vm.loadingDetail
                  ? [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "close-on-click": "",
                            "close-on-content-click": "",
                            "offset-y": "",
                            left: "",
                            "nudge-bottom": 10,
                            transition: "slide-y-transition",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "ml-2",
                                            attrs: {
                                              color: "grey-900",
                                              disabled: _vm.loadingDetail,
                                            },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("v-icon", { attrs: { left: "" } }, [
                                          _vm._v("mdi-file-plus"),
                                        ]),
                                        _vm._v("Crear documento"),
                                        _c(
                                          "v-icon",
                                          { attrs: { size: "18", right: "" } },
                                          [_vm._v("mdi-chevron-down")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3576978952
                          ),
                        },
                        [
                          _c(
                            "v-list",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "px-3",
                                  attrs: {
                                    ripple: false,
                                    to: {
                                      name: "DocumentsClone",
                                      params: {
                                        id: _vm.instance.id,
                                        ..._vm.$route.params,
                                      },
                                      query: {
                                        document_type: _vm.instance.type,
                                      },
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-2" },
                                    [_vm._v("Duplicar")]
                                  ),
                                ],
                                1
                              ),
                              _vm.instance.type === "CL52"
                                ? _c(
                                    "v-list-item",
                                    {
                                      staticClass: "px-3",
                                      attrs: {
                                        ripple: false,
                                        to: {
                                          name: "DocumentsClone",
                                          params: {
                                            id: _vm.instance.id,
                                            ..._vm.$route.params,
                                          },
                                          query: {
                                            document_type: "CL33",
                                            document_parent: _vm.instance.type,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "body-2" },
                                        [_vm._v("Facturar guía de despacho")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.availableNotes.length > 0
                                ? _vm._l(
                                    _vm.availableNotes,
                                    function (item, index) {
                                      return _c(
                                        "v-list-item",
                                        {
                                          key: index,
                                          staticClass: "px-3",
                                          attrs: { ripple: false },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handlerNoteClick(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "body-2" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.getNoteLabel(item))
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "v-col",
        { staticClass: "px-0", staticStyle: { "z-index": "0" } },
        [
          _vm.loadingDetail
            ? _c("skeleton-detail")
            : _c("div", { staticClass: "d-flex" }, [
                _c(
                  "div",
                  {
                    staticClass: "mr-6",
                    staticStyle: { "min-width": "400px" },
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { position: "fixed!important" } },
                      [
                        _c(
                          "v-img",
                          {
                            attrs: {
                              contain: "",
                              width: 400,
                              height: 110,
                              src: require(`@/assets/backgrounds/background-document-detail.svg`),
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "px-4 pt-4 subtitle-2 white--text font-weight-bold d-inline-block text-truncate",
                                staticStyle: { "max-width": "300px" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("nameDocumentsType")(
                                        _vm.instance?.type ?? ""
                                      )
                                    ) +
                                    " Nº" +
                                    _vm._s(_vm.instance.number) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "v-row",
                              {
                                staticClass: "ml-2 mt-3",
                                attrs: { align: "end", "no-gutters": "" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "py-0 px-2",
                                    attrs: { cols: "5" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "d-block body-1 white--text",
                                      },
                                      [_vm._v("Total")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "subtitle-2 white--text" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "subtitle-2 white--text",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "font-weight-bold",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$fmt.currency(
                                                      _vm.documentCurrency,
                                                      _vm.instance.amount_total
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "py-0 px-2",
                                    attrs: { cols: "5" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "d-block body-1 white--text",
                                      },
                                      [_vm._v("Fecha")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "subtitle-2 white--text" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("date")(
                                                  _vm.instance.date
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.instance.assignee_tax_id
                          ? _c(
                              "v-card",
                              {
                                staticClass: "mt-3 pb-2",
                                staticStyle: {
                                  "border-color": "var(--grey-900)",
                                },
                                attrs: { color: "green-50", outlined: "" },
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "px-5 pt-4",
                                    attrs: {
                                      align: "center",
                                      "no-gutters": "",
                                    },
                                  },
                                  [
                                    _c("v-col", { staticClass: "pa-0" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "ml-n1 subtitle-2 grey-900--text font-weight-bold",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "18",
                                                left: "",
                                                color: "grey-900",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "mdi-file-arrow-left-right"
                                              ),
                                            ]
                                          ),
                                          _vm._v("Información de cesión"),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c(
                                      "v-col",
                                      { staticClass: "pa-0 text-right" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              text: "",
                                              color: "grey-900",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.dialogDetailAssign = true
                                              },
                                            },
                                          },
                                          [_vm._v("Ver más información")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-card-text",
                                  { staticClass: "px-5" },
                                  [
                                    _c("v-col", { staticClass: "pa-0" }, [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "d-block body-1 grey-900--text",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.instance.assignee_name ||
                                                "Sin definir"
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "subtitle-2 grey-900--text",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatRut(
                                                    _vm.instance.assignee_tax_id
                                                  ) || "Sin definir"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "mt-5",
                                        attrs: {
                                          "no-gutters": "",
                                          align: "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "pa-0",
                                            attrs: { cols: "8" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "d-block body-1 grey-900--text",
                                              },
                                              [_vm._v("Fecha de cesión")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "subtitle-2 grey-900--text",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "dateTimeSecond"
                                                        )(
                                                          _vm.instance
                                                            .assignment_date
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-col",
                                          { staticClass: "pa-0" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "d-block body-1 grey-900--text",
                                              },
                                              [_vm._v("Estado")]
                                            ),
                                            _c("chip-status", {
                                              attrs: {
                                                status:
                                                  _vm.instance
                                                    .assignment_agency_status,
                                                showDetail: true,
                                                isTooltip: false,
                                                type: "assign",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-card",
                          {
                            staticClass: "pa-0 mt-4",
                            staticStyle: { position: "fixed!important" },
                            attrs: {
                              width: "400",
                              transition: "slide-y-transition",
                              "min-height": _vm.instance.assignee_tax_id
                                ? "calc(100% - 585px)"
                                : "calc(100% - 295px)",
                              flat: "",
                            },
                          },
                          [
                            _c(
                              "v-toolbar",
                              {
                                attrs: {
                                  color: "transparent",
                                  flat: "",
                                  height: "46",
                                },
                              },
                              [
                                _c(
                                  "v-toolbar-title",
                                  {
                                    staticClass:
                                      "px-5 subtitle-2 grey-500--text font-weight-bold",
                                  },
                                  [_vm._v("Resumen del documento")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-card-text",
                              {
                                staticClass: "overflow-y-auto pa-0",
                                style:
                                  _vm.$vuetify.breakpoint.height <= 700
                                    ? ` max-height: calc(100vh - ${
                                        _vm.instance.assignee_tax_id
                                          ? "530px"
                                          : "320px"
                                      })`
                                    : `max-height: calc(100vh - ${
                                        _vm.instance.assignee_tax_id
                                          ? "300px"
                                          : "300px"
                                      })`,
                              },
                              [
                                _c("v-divider"),
                                _c(
                                  "div",
                                  { staticClass: "py-4 px-5" },
                                  [
                                    _c(
                                      "v-list",
                                      {
                                        staticClass:
                                          "v-list-form-main transparent pa-0",
                                      },
                                      [
                                        _c(
                                          "v-list-item",
                                          { staticClass: "pa-0" },
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "grey-500--text subtitle-2",
                                              },
                                              [_vm._v("Razón Social")]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              { staticClass: "body-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.instance || {})
                                                      .customer_name
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          { staticClass: "pa-0" },
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "grey-500--text subtitle-2",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("generals.RUT"))
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              { staticClass: "body-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatRut(
                                                      (_vm.instance || {})
                                                        .customer_tax_id
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          { staticClass: "pa-0" },
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "grey-500--text subtitle-2",
                                              },
                                              [_vm._v("Tipo de documento")]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              { staticClass: "body-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("nameDocumentsType")(
                                                      (_vm.instance || {})
                                                        .type || ""
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm.instance.status !== "draft"
                                          ? _c(
                                              "v-list-item",
                                              { staticClass: "pa-0" },
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass:
                                                      "grey-500--text subtitle-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("generals.Folio")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-list-item-subtitle",
                                                  { staticClass: "body-1" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.instance.number
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "v-list-item",
                                          { staticClass: "pa-0" },
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "grey-500--text subtitle-2",
                                              },
                                              [_vm._v("ID")]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              { staticClass: "body-1" },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: {
                                                      color: "grey-background",
                                                      right: "",
                                                      transition:
                                                        "scale-transition",
                                                      "max-width": "300",
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "grey-300--text",
                                                                  attrs: {
                                                                    text: "",
                                                                    ripple: false,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.toClipboard(
                                                                          _vm
                                                                            .instance
                                                                            .id
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.instance
                                                                      .id
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ]),
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "d-block px-3 py-2",
                                                      },
                                                      [_vm._v("Copiar")]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          { staticClass: "pa-0" },
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "grey-500--text subtitle-2",
                                              },
                                              [_vm._v("Creado el")]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              { staticClass: "body-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("dateTimeSecond")(
                                                      _vm.instance.created
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm.instance.summary_id
                                          ? _c(
                                              "v-list-item",
                                              { staticClass: "pa-0" },
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass:
                                                      "grey-500--text subtitle-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        [
                                                          "PE20",
                                                          "P40",
                                                        ].includes(
                                                          _vm.instance.type
                                                        )
                                                          ? "Reversión"
                                                          : "Baja"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-list-item-subtitle",
                                                  { staticClass: "body-1" },
                                                  [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        staticClass:
                                                          "d-flex align-center grey-900--text text-decoration-none",
                                                        attrs: {
                                                          to: {
                                                            name: "SummariesRetrieve",
                                                            params: {
                                                              id: _vm.instance
                                                                .summary_id,
                                                              ..._vm.currentParams,
                                                            },
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.instance
                                                                .summary_id
                                                            ) +
                                                            " "
                                                        ),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              right: "",
                                                              color: "grey-900",
                                                              size: "14",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-open-in-new"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.instance?.batch_id
                                          ? _c(
                                              "v-list-item",
                                              { staticClass: "pa-0" },
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass:
                                                      "grey-500--text subtitle-2",
                                                  },
                                                  [_vm._v("Lote")]
                                                ),
                                                _c(
                                                  "v-list-item-subtitle",
                                                  { staticClass: "body-1" },
                                                  [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        staticClass:
                                                          "d-flex align-center grey-900--text text-decoration-none",
                                                        attrs: {
                                                          to: {
                                                            name: "DocumentsBatchRetrieve",
                                                            params: {
                                                              id: _vm.instance
                                                                .batch_id,
                                                              ..._vm.currentParams,
                                                            },
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.instance
                                                                .batch_id
                                                            ) +
                                                            " "
                                                        ),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              right: "",
                                                              color: "grey-900",
                                                              size: "14",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-open-in-new"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { staticClass: "px-5" },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        attrs: {
                                          "no-gutters": "",
                                          align: "center",
                                          justify: "space-between",
                                        },
                                      },
                                      [
                                        _c("v-col", { staticClass: "pa-0" }, [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "ml-n1 subtitle-2 grey-700--text font-weight-bold",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    size: "18",
                                                    left: "",
                                                    color: "grey-700",
                                                  },
                                                },
                                                [_vm._v("mdi-currency-usd")]
                                              ),
                                              _vm._v("Totales"),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c("v-divider", { staticClass: "my-3" }),
                                    _c(
                                      "v-list",
                                      {
                                        staticClass: "transparent pa-0",
                                        attrs: { width: "100%" },
                                      },
                                      [
                                        _c(
                                          "v-list-item",
                                          [
                                            _c(
                                              "v-list-item-title",
                                              { staticClass: "subtitle-2" },
                                              [_vm._v("Subtotal")]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              {
                                                staticClass:
                                                  "text-right font-weight-bold",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$fmt.currency(
                                                      _vm.documentCurrency,
                                                      _vm.instance
                                                        .amount_subtotal
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          [
                                            _c(
                                              "v-list-item-title",
                                              { staticClass: "subtitle-2" },
                                              [_vm._v("Descuento")]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              {
                                                staticClass:
                                                  "text-right grey-500--text font-weight-bold",
                                              },
                                              [
                                                (_vm.instance || {})
                                                  .amount_discount
                                                  ? [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$fmt.currency(
                                                            _vm.documentCurrency,
                                                            _vm.instance
                                                              .amount_discount
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  : [_vm._v("-")],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        (_vm.activeDocument || {})
                                          .has_taxes_detail
                                          ? [
                                              _c(
                                                "v-list-item",
                                                { staticClass: "mt-3" },
                                                [
                                                  _c(
                                                    "v-list-item-title",
                                                    {
                                                      staticClass: "subtitle-2",
                                                    },
                                                    [_vm._v("Exento")]
                                                  ),
                                                  _c(
                                                    "v-list-item-subtitle",
                                                    {
                                                      staticClass:
                                                        "text-right grey-500--text font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$fmt.currency(
                                                            _vm.documentCurrency,
                                                            _vm.instance
                                                              ?.amount_exempt ??
                                                              0
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              (_vm.activeDocument || {})
                                                .has_taxes
                                                ? [
                                                    _c(
                                                      "v-list-item",
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "subtitle-2",
                                                          },
                                                          [_vm._v("Neto")]
                                                        ),
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          {
                                                            staticClass:
                                                              "text-right grey-500--text font-weight-bold",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$fmt.currency(
                                                                  _vm.documentCurrency,
                                                                  _vm.instance
                                                                    .amount_net
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-list-item",
                                                      { staticClass: "mt-3" },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "subtitle-2",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Impuestos (" +
                                                                _vm._s(
                                                                  _vm
                                                                    .activeDocument
                                                                    .tax
                                                                ) +
                                                                "%)"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          {
                                                            staticClass:
                                                              "text-right grey-500--text font-weight-bold",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$fmt.currency(
                                                                  _vm.documentCurrency,
                                                                  _vm.instance
                                                                    .amount_tax
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ]
                                          : _vm._e(),
                                        _c(
                                          "v-list-item",
                                          { staticClass: "mt-3" },
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "subtitle-2 grey-500--text font-weight-bold subtitle-2",
                                              },
                                              [_vm._v("Total documento")]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              {
                                                staticClass:
                                                  "text-right subtitle-2 grey-500--text font-weight-bold",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$fmt.currency(
                                                      _vm.documentCurrency,
                                                      _vm.instance.amount_total
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "pb-5",
                    staticStyle: { flex: "1", "min-width": "180px" },
                  },
                  [
                    _c(
                      "v-card",
                      { staticClass: "mt-1", attrs: { flat: "" } },
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              color: "transparent",
                              flat: "",
                              height: "46",
                            },
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              {
                                staticClass:
                                  "px-5 subtitle-2 grey-700--text font-weight-semibold",
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    attrs: {
                                      align: "center",
                                      "no-gutters": "",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "ml-n1 mr-2",
                                      attrs: {
                                        width: 20,
                                        src: require(`@/assets/ax/${
                                          _vm.$store?.state?.auth?.account
                                            ?.country === "PE"
                                            ? "sunat"
                                            : "sii"
                                        }--icon.png`),
                                      },
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$store?.state?.auth?.account
                                            ?.country === "PE"
                                            ? "Sunat"
                                            : "Servicio de impuestos internos"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-divider"),
                        _c("v-card-text", { staticClass: "pa-0" }, [
                          _c(
                            "div",
                            { staticClass: "pt-4 px-5 pb-2" },
                            [
                              _c(
                                "v-list",
                                {
                                  staticClass:
                                    "v-list-form-status transparent pa-0",
                                },
                                [
                                  _c(
                                    "v-list-item",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticClass:
                                            "grey-500--text subtitle-2 font-weight-bold",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-3",
                                              attrs: {
                                                size: "20",
                                                left: "",
                                                color: "grey-900",
                                              },
                                            },
                                            [_vm._v("mdi-clipboard")]
                                          ),
                                          _vm._v("Estado"),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-subtitle",
                                        { staticClass: "body-1" },
                                        [
                                          !_vm.instance.status ||
                                          _vm.instance?.status?.code === "IMP"
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    loading:
                                                      _vm.taxAgencyLoader,
                                                    text: "",
                                                    color: "grey-900",
                                                    ripple: false,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.taxAgencyService(
                                                        "documents",
                                                        "documents",
                                                        "irs_status"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Actualizar estado")]
                                              )
                                            : _vm.instance?.status?.id === "PDR"
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text--disabled d-block",
                                                },
                                                [_vm._v("Sin estado")]
                                              )
                                            : _c("chip-status", {
                                                attrs: {
                                                  status:
                                                    _vm.instance?.status
                                                      ?.code ||
                                                    _vm.instance.status,
                                                  detail:
                                                    _vm.instance
                                                      .agency_status ||
                                                    _vm.instance
                                                      .agency_status_info
                                                      ? `${_vm.instance.agency_status} <br> ${_vm.instance.agency_status_info}`
                                                      : null,
                                                  showDetail: true,
                                                  isTooltip: false,
                                                  type: "documents",
                                                },
                                              }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  (_vm.instance || {}).agency_status
                                    ? _c(
                                        "v-list-item",
                                        { staticClass: "pa-0" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticClass:
                                                "grey-500--text subtitle-2 font-weight-bold",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-3",
                                                  attrs: {
                                                    size: "20",
                                                    left: "",
                                                    color: "grey-900",
                                                  },
                                                },
                                                [_vm._v("mdi-clipboard-search")]
                                              ),
                                              _vm._v("Detalle del estado"),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            {
                                              staticClass:
                                                "body-1 align-self-start mt-2",
                                              staticStyle: {
                                                "white-space":
                                                  "normal !important",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.instance.agency_status
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  (_vm.instance || {}).agency_status_info
                                    ? _c(
                                        "v-list-item",
                                        { staticClass: "pa-0" },
                                        [
                                          _c("v-list-item-title", {
                                            staticClass:
                                              "grey-500--text subtitle-2",
                                          }),
                                          _c(
                                            "v-list-item-subtitle",
                                            {
                                              staticClass:
                                                "body-1 align-self-start",
                                              staticStyle: {
                                                "white-space":
                                                  "normal !important",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-sheet",
                                                {
                                                  staticClass: "grey-300--text",
                                                  staticStyle: {
                                                    "justify-content": "left",
                                                  },
                                                },
                                                [
                                                  _c("span", {}, [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.instance.agency_status_info.slice(
                                                          0,
                                                          256
                                                        )
                                                      ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.instance
                                                            .agency_status_info
                                                            .length >= 256
                                                            ? "..."
                                                            : ""
                                                        )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  (_vm.instance || {})
                                    ?.agency_status_detail_list
                                    ? _c(
                                        "v-list-item",
                                        { staticClass: "pa-0" },
                                        [
                                          _c("v-list-item-title", {
                                            staticClass:
                                              "grey-500--text subtitle-2",
                                          }),
                                          (_vm.instance || {})
                                            .agency_status_detail_list
                                            ? _c(
                                                "v-list-item-subtitle",
                                                {
                                                  staticClass:
                                                    "body-1 align-self-start mt-2",
                                                  staticStyle: {
                                                    "white-space":
                                                      "normal !important",
                                                  },
                                                },
                                                [
                                                  _vm._l(
                                                    _vm.instance?.agency_status_detail_list.slice(
                                                      0,
                                                      2
                                                    ),
                                                    function (detail, i) {
                                                      return _c(
                                                        "span",
                                                        {
                                                          key: i,
                                                          staticClass:
                                                            "d-block mb-2",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              detail.slice(
                                                                0,
                                                                156
                                                              ) &&
                                                                i ===
                                                                  _vm.instance.agency_status_detail_list.slice(
                                                                    0,
                                                                    2
                                                                  ).length -
                                                                    1 &&
                                                                detail.length >=
                                                                  156
                                                                ? `${detail}...`
                                                                : detail
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  _vm.instance
                                                    .agency_status_detail_list
                                                    .length >= 2
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            text: "",
                                                            color: "grey-900",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.dialogSunat = true
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("Ver más")]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.$store.state.auth.account.country !== "PE"
                                    ? _c(
                                        "v-list-item",
                                        { staticClass: "pa-0" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticClass:
                                                "grey-500--text subtitle-2 font-weight-bold",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-3",
                                                  attrs: {
                                                    size: "20",
                                                    left: "",
                                                    color: "grey-900",
                                                  },
                                                },
                                                [_vm._v("mdi-pound")]
                                              ),
                                              _vm._v("Track ID"),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            { staticClass: "body-1" },
                                            [
                                              _vm.instance?.agency_id
                                                ? _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        color:
                                                          "grey-background",
                                                        right: "",
                                                        transition:
                                                          "scale-transition",
                                                        "max-width": "300",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  _vm._g(
                                                                    {
                                                                      staticClass:
                                                                        "grey-300--text",
                                                                      staticStyle:
                                                                        {
                                                                          "justify-content":
                                                                            "left",
                                                                        },
                                                                      attrs: {
                                                                        text: "",
                                                                        ripple: false,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.toClipboard(
                                                                              _vm
                                                                                .instance
                                                                                ?.agency_id
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .instance
                                                                          ?.agency_id
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        2497270072
                                                      ),
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "d-block px-3 py-2",
                                                        },
                                                        [_vm._v("Copiar")]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm.instance?.rec_status
                      ? _c(
                          "v-card",
                          { staticClass: "mt-5", attrs: { flat: "" } },
                          [
                            _c(
                              "v-toolbar",
                              {
                                attrs: {
                                  color: "transparent",
                                  flat: "",
                                  height: "46",
                                },
                              },
                              [
                                _c(
                                  "v-toolbar-title",
                                  {
                                    staticClass:
                                      "px-5 subtitle-2 grey-700--text font-weight-semibold",
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          size: "18",
                                          left: "",
                                          color: "grey-700",
                                        },
                                      },
                                      [_vm._v("mdi-domain")]
                                    ),
                                    _vm._v("Respuesta comercial"),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("v-divider"),
                            _c("v-card-text", { staticClass: "pa-0" }, [
                              _c(
                                "div",
                                { staticClass: "pt-4 px-5 pb-2" },
                                [
                                  _c(
                                    "v-list",
                                    {
                                      staticClass:
                                        "v-list-form-status transparent pa-0",
                                    },
                                    [
                                      _c(
                                        "v-list-item",
                                        { staticClass: "pa-0" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticClass:
                                                "grey-500--text subtitle-2 font-weight-bold",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-3",
                                                  attrs: {
                                                    size: "20",
                                                    left: "",
                                                    color: "grey-900",
                                                  },
                                                },
                                                [_vm._v("mdi-clipboard")]
                                              ),
                                              _vm._v("Estado"),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            { staticClass: "body-1" },
                                            [
                                              _c("chip-status", {
                                                attrs: {
                                                  status:
                                                    _vm.instance?.rec_status,
                                                  detail:
                                                    _vm.instance
                                                      ?.rec_status_info || null,
                                                  type: "purchases",
                                                  showDetail: true,
                                                  isTooltip: false,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        { staticClass: "pa-0" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticClass:
                                                "grey-500--text subtitle-2 font-weight-bold",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-3",
                                                  attrs: {
                                                    size: "20",
                                                    left: "",
                                                    color: "grey-900",
                                                  },
                                                },
                                                [_vm._v("mdi-clipboard-search")]
                                              ),
                                              _vm._v("Detalle del estado"),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            {
                                              staticClass:
                                                "body-1 align-self-start mt-2",
                                              staticStyle: {
                                                "white-space":
                                                  "normal !important",
                                              },
                                            },
                                            [
                                              _vm.hasRecStatusInfo
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-block body-2 grey-300--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.instance
                                                            .rec_status_info
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-2 text--disabled font-italic",
                                                    },
                                                    [_vm._v("Sin especificar")]
                                                  ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.hasAgencyRecStatusInfo
                                        ? _c(
                                            "v-list-item",
                                            { staticClass: "pa-0" },
                                            [
                                              _c(
                                                "v-list-item-title",
                                                {
                                                  staticClass:
                                                    "grey-500--text subtitle-2 font-weight-bold",
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-3",
                                                      attrs: {
                                                        size: "20",
                                                        left: "",
                                                        color: "grey-900",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.agencyRecStatusIcon
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    "Estado " +
                                                      _vm._s(
                                                        _vm.$t("generals.SII")
                                                      )
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-list-item-subtitle",
                                                { staticClass: "body-1" },
                                                [
                                                  _c("chip-status", {
                                                    attrs: {
                                                      status:
                                                        _vm.instance
                                                          ?.rec_status,
                                                      customText:
                                                        _vm.instance
                                                          .agency_rec_status_info,
                                                      noTruncate: true,
                                                      type: "purchases",
                                                      showDetail: true,
                                                      isTooltip: false,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "v-list-item",
                                        { staticClass: "pa-0" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticClass:
                                                "grey-500--text subtitle-2 font-weight-bold",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-3",
                                                  attrs: {
                                                    size: "20",
                                                    left: "",
                                                    color: "grey-900",
                                                  },
                                                },
                                                [_vm._v("mdi-calendar-blank")]
                                              ),
                                              _vm._v("Fecha"),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-subtitle",
                                            { staticClass: "body-1" },
                                            [
                                              _vm.instance.rec_status_date
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "d-block body-2 grey-300--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "dateTimeSecond"
                                                          )(
                                                            _vm.instance
                                                              .rec_status_date
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "body-2 text--disabled font-italic",
                                                    },
                                                    [_vm._v("Sin especificar")]
                                                  ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.instance.pdf_link
                      ? _c(
                          "v-card",
                          { staticClass: "mt-5", attrs: { flat: "" } },
                          [
                            _c(
                              "v-card-text",
                              { staticClass: "px-7 py-6" },
                              [
                                _c(
                                  "v-row",
                                  { attrs: { align: "center" } },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          size: "18",
                                          left: "",
                                          color: "grey-700",
                                        },
                                      },
                                      [_vm._v("mdi-link-variant")]
                                    ),
                                    _c(
                                      "v-col",
                                      { staticClass: "pa-0 pr-2" },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "publicLink",
                                          attrs: {
                                            outlined: "",
                                            readonly: "",
                                            type: "text",
                                            "hide-details": "",
                                            "single-line": "",
                                            dense: "",
                                            prefix: "Enlace público:",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "append",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "pl-4 mr-1 body-2",
                                                        staticStyle: {
                                                          top: "-4px",
                                                        },
                                                        attrs: {
                                                          text: "",
                                                          color: "grey-900",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.toClipboard(
                                                              _vm.instance
                                                                .pdf_link
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("Copiar")]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            1940054062
                                          ),
                                          model: {
                                            value: _vm.instance.pdf_link,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.instance,
                                                "pdf_link",
                                                $$v
                                              )
                                            },
                                            expression: "instance.pdf_link",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-card",
                      { staticClass: "mt-5", attrs: { flat: "" } },
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              color: "transparent",
                              flat: "",
                              height: "46",
                            },
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              {
                                staticClass:
                                  "px-5 subtitle-2 grey-700--text font-weight-semibold",
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      size: "18",
                                      left: "",
                                      color: "grey-700",
                                    },
                                  },
                                  [_vm._v("mdi-timeline-clock")]
                                ),
                                _vm._v("Eventos"),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-divider"),
                        _c(
                          "v-card-text",
                          { staticClass: "pa-0" },
                          [
                            _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { "no-gutters": "" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "pa-0 pb-3 d-flex flex-column",
                                    attrs: { cols: "6" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "px-5 pt-5 pb-2 d-flex align-center",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "subtitle-2 grey-500--text font-weight-semibold",
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  size: "16",
                                                  left: "",
                                                  color: "grey-500",
                                                },
                                              },
                                              [_vm._v("mdi-file")]
                                            ),
                                            _vm._v("Documento "),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm.eventLoading
                                      ? _c("v-skeleton-loader", {
                                          staticClass:
                                            "mb-2 panel px-1 rounded-md",
                                          attrs: {
                                            transition: "fade-transition",
                                            type: "list",
                                          },
                                        })
                                      : (_vm.eventsList || []).length
                                      ? [
                                          _c(
                                            "v-list",
                                            {
                                              staticClass:
                                                "transparent pa-0 dense",
                                            },
                                            _vm._l(_vm.events, function (d, i) {
                                              return _c(
                                                "div",
                                                { key: i },
                                                [
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      key: i,
                                                      staticClass: "px-5",
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-icon",
                                                        {
                                                          staticClass:
                                                            "pr-2 my-3",
                                                        },
                                                        [
                                                          _c(
                                                            "v-avatar",
                                                            {
                                                              attrs: {
                                                                size: "38",
                                                                color:
                                                                  "grey-900",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    size: "22",
                                                                    color:
                                                                      "white",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.currentEvent(
                                                                        d.event_type
                                                                      ).icon
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-list-item-title",
                                                        {
                                                          staticClass: "ml-n5",
                                                          staticStyle: {
                                                            "white-space":
                                                              "normal",
                                                            overflow: "visible",
                                                            "text-overflow":
                                                              "unset",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "d-block grey-700--text body-1",
                                                            },
                                                            [
                                                              _c("span", {
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      _vm.currentEvent(
                                                                        d.event_type
                                                                      ).summary
                                                                    ),
                                                                },
                                                              }),
                                                              d.description
                                                                ? [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "text-body-2 grey-700--text",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " — " +
                                                                            _vm._s(
                                                                              d.description
                                                                            )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                : _vm._e(),
                                                            ],
                                                            2
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "d-block body-2 grey-300--text",
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "mr-1",
                                                                  attrs: {
                                                                    size: "14",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-calendar-blank"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "dateTimeSecond"
                                                                  )(d.created)
                                                                ) + " "
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }),
                                            0
                                          ),
                                        ]
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-center justify-center flex-grow-1 px-5",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 text--disabled font-italic",
                                              },
                                              [
                                                _vm._v(
                                                  "Sin eventos de documento"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                  ],
                                  2
                                ),
                                _c("v-divider", {
                                  staticClass: "my-0 pa-0",
                                  attrs: { height: "100%", vertical: "" },
                                }),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "pa-0 pb-3 d-flex flex-column",
                                    attrs: { cols: "6" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "px-5 pt-5 pb-2 d-flex align-center",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "subtitle-2 grey-500--text font-weight-semibold",
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  size: "16",
                                                  left: "",
                                                  color: "grey-500",
                                                },
                                              },
                                              [_vm._v("mdi-send")]
                                            ),
                                            _vm._v("Distribución "),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm.distEventLoading
                                      ? _c("v-skeleton-loader", {
                                          staticClass:
                                            "mb-2 panel px-1 rounded-md",
                                          attrs: {
                                            transition: "fade-transition",
                                            type: "list",
                                          },
                                        })
                                      : _vm.distEventsList.length
                                      ? [
                                          _c(
                                            "v-list",
                                            {
                                              staticClass:
                                                "transparent pa-0 dense",
                                            },
                                            _vm._l(
                                              _vm.distEvents,
                                              function (d, i) {
                                                return _c(
                                                  "div",
                                                  { key: "dist-" + i },
                                                  [
                                                    _c(
                                                      "v-list-item",
                                                      {
                                                        staticClass:
                                                          "px-5 py-0",
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-icon",
                                                          {
                                                            staticClass:
                                                              "pr-2 my-3",
                                                          },
                                                          [
                                                            _c(
                                                              "v-avatar",
                                                              {
                                                                attrs: {
                                                                  size: "38",
                                                                  color:
                                                                    "grey-900",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      size: "22",
                                                                      color:
                                                                        "white",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.currentDistEvent(
                                                                          d.source_type
                                                                        )
                                                                          .icon ||
                                                                          "mdi-email-outline"
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "ml-n5",
                                                            staticStyle: {
                                                              "white-space":
                                                                "normal",
                                                              overflow:
                                                                "visible",
                                                              "text-overflow":
                                                                "unset",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "d-block grey-700--text body-1",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "font-weight-bold",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.distEventTypeLabel(
                                                                          d.dist_event_type
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                [
                                                                  "SNT",
                                                                  "NST",
                                                                ].includes(
                                                                  d.dist_event_type
                                                                )
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "green-500--text font-weight-bold",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.distSourceTypeLabel(
                                                                                d.source_type
                                                                              )
                                                                            )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                d.address &&
                                                                d.address.trim()
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        " a " +
                                                                          _vm._s(
                                                                            d.address
                                                                          )
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "d-block body-2 grey-300--text",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mr-1",
                                                                    attrs: {
                                                                      size: "14",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-calendar-blank"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "dateTimeSecond"
                                                                    )(
                                                                      d.timestamp
                                                                    )
                                                                  ) + " "
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-center justify-center flex-grow-1 px-5",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 text--disabled font-italic",
                                              },
                                              [
                                                _vm._v(
                                                  "Sin eventos de distribución"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.eventsList.length > 3 ||
                        _vm.distEventsList.length > 3
                          ? [
                              _c("v-divider"),
                              _c(
                                "v-card-actions",
                                { staticClass: "px-5 py-2" },
                                [
                                  _c("v-spacer"),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "grey-900", text: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showMoreEvents =
                                            !_vm.showMoreEvents
                                          _vm.showMoreDistEvents =
                                            !_vm.showMoreDistEvents
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            !_vm.showMoreEvents
                                              ? "Ver todos los eventos"
                                              : "Ver menos eventos"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "v-expansion-panels",
                      {
                        staticClass: "mt-5",
                        model: {
                          value: _vm.panelRelatedDocuments,
                          callback: function ($$v) {
                            _vm.panelRelatedDocuments = $$v
                          },
                          expression: "panelRelatedDocuments",
                        },
                      },
                      [
                        _c(
                          "v-expansion-panel",
                          [
                            _c(
                              "v-expansion-panel-header",
                              { staticClass: "px-4 py-3" },
                              [
                                _c(
                                  "v-row",
                                  {
                                    attrs: {
                                      "no-gutters": "",
                                      align: "center",
                                      justify: "space-between",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              size: "18",
                                              left: "",
                                              color: "grey-700",
                                            },
                                          },
                                          [_vm._v("mdi-file-document-multiple")]
                                        ),
                                        _vm._v("Referencias"),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-expansion-panel-content",
                              { staticClass: "px-0" },
                              [
                                !_vm.references?.length
                                  ? _c("v-empty-state", {
                                      staticClass: "mt-n2 pb-2",
                                      attrs: {
                                        type: "documents",
                                        id: "documentos",
                                        customClass: "mt-n5",
                                        isFree: true,
                                        title:
                                          "No hay información de referencias",
                                        height: 199,
                                      },
                                    })
                                  : _c("v-simple-table", {
                                      staticClass:
                                        "px-0 no-hover table-not-rounded",
                                      attrs: { dense: "" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function () {
                                            return [
                                              _c(
                                                "thead",
                                                [
                                                  _c("tr", [
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-left grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          "min-width": "180px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Tipo de documento"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          "min-width": "120px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "generals.Correlativo"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right grey-700--text font-weight-medium",
                                                        staticStyle: {
                                                          "min-width": "70px",
                                                        },
                                                      },
                                                      [_vm._v("Fecha del doc.")]
                                                    ),
                                                  ]),
                                                  _c("v-divider", {
                                                    staticStyle: {
                                                      position: "absolute",
                                                      "margin-top": "-10px",
                                                      "min-width": "100%",
                                                      "margin-left": "-1px",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "tbody",
                                                _vm._l(
                                                  _vm.references,
                                                  function (item) {
                                                    return _c(
                                                      "tr",
                                                      {
                                                        key: item.number,
                                                        staticStyle: {
                                                          cursor: "pointer",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.goTo(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "body-2",
                                                          },
                                                          [
                                                            item.type
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "d-inline-block text-truncate",
                                                                    staticStyle:
                                                                      {
                                                                        "max-width":
                                                                          "99%",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm.$store
                                                                      .state
                                                                      .auth
                                                                      .account
                                                                      .country !==
                                                                    "PE"
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm._f(
                                                                                  "nameReferencesType"
                                                                                )(
                                                                                  item.type
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm._f(
                                                                                  "nameDocumentsType"
                                                                                )(
                                                                                  item.type
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "body-2 text--disabled font-italic",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Sin especificar"
                                                                    ),
                                                                  ]
                                                                ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-right body-2",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.number
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-right body-2",
                                                          },
                                                          [
                                                            item.date
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "date"
                                                                      )(
                                                                        item.date
                                                                      )
                                                                    )
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "600",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogGrant,
            callback: function ($$v) {
              _vm.dialogGrant = $$v
            },
            expression: "dialogGrant",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-0" },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "transparent",
                  attrs: { flat: "", height: "46" },
                },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass:
                        "px-5 subtitle-2 grey-500--text font-weight-semibold",
                    },
                    [_vm._v("Ceder documento")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "mr-3",
                          attrs: { align: "center", justify: "center" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                "retain-focus-on-click": "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.dialogGrant = false
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { color: "grey-500", size: "20" } },
                                [_vm._v("mdi-close")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-0 py-4" },
                [
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pa-0" },
                        [
                          _c(
                            "v-list",
                            {
                              staticClass:
                                "v-list-form-extended transparent pa-0",
                            },
                            [
                              _c(
                                "v-list-item",
                                { staticClass: "px-5 pt-0" },
                                [
                                  _c("v-list-item-title", [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v("Cedida a")]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "px-5" },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(_vm.$t("generals.RUT"))),
                                  ]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c("v-text-field", {
                                            directives: [
                                              {
                                                name: "dni",
                                                rawName: "v-dni",
                                                value: "CL",
                                                expression: "'CL'",
                                              },
                                            ],
                                            attrs: {
                                              error:
                                                _vm.$v.grant.assigneeTaxId
                                                  .$error,
                                              outlined: "",
                                              "hide-details": "",
                                              required: "",
                                              "single-line": "",
                                              dense: "",
                                              maxlength: "32",
                                            },
                                            model: {
                                              value:
                                                _vm.$v.grant.assigneeTaxId
                                                  .$model,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.$v.grant.assigneeTaxId,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "$v.grant.assigneeTaxId.$model",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "py-2 px-5" },
                                [
                                  _c("v-list-item-title", [_vm._v("Nombre")]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          error:
                                            _vm.$v.grant.assigneeName.$error,
                                          outlined: "",
                                          "hide-details": "",
                                          required: "",
                                          "single-line": "",
                                          dense: "",
                                          maxlength: "100",
                                        },
                                        model: {
                                          value:
                                            _vm.$v.grant.assigneeName.$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.grant.assigneeName,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.grant.assigneeName.$model",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "px-5" },
                                [
                                  _c("v-list-item-title", [_vm._v("Email")]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          error:
                                            _vm.$v.grant.assigneeEmail.$error,
                                          outlined: "",
                                          "hide-details": "",
                                          required: "",
                                          "single-line": "",
                                          dense: "",
                                          maxlength: "70",
                                        },
                                        model: {
                                          value:
                                            _vm.$v.grant.assigneeEmail.$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.grant.assigneeEmail,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.grant.assigneeEmail.$model",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "py-2 px-5" },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Dirección"),
                                  ]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          error:
                                            _vm.$v.grant.assigneeAddress.$error,
                                          outlined: "",
                                          "hide-details": "",
                                          required: "",
                                          "single-line": "",
                                          dense: "",
                                          maxlength: "70",
                                        },
                                        model: {
                                          value:
                                            _vm.$v.grant.assigneeAddress.$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.grant.assigneeAddress,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.grant.assigneeAddress.$model",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("v-divider", { staticClass: "my-3" }),
                              _c(
                                "v-list-item",
                                { staticClass: "px-5" },
                                [
                                  _c("v-list-item-title", [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v("Cedida por")]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "pt-2 pb-1 px-5" },
                                [
                                  _c("v-list-item-title", [_vm._v("Email")]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          error:
                                            _vm.$v.grant.assignorEmail.$error,
                                          outlined: "",
                                          "hide-details": "",
                                          required: "",
                                          "single-line": "",
                                          dense: "",
                                          maxlength: "70",
                                        },
                                        model: {
                                          value:
                                            _vm.$v.grant.assignorEmail.$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.grant.assignorEmail,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.grant.assignorEmail.$model",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "py-2 px-5" },
                                [
                                  _c("v-list-item-title", [_vm._v("Nombre")]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          error:
                                            _vm.$v.grant.assignorName.$error,
                                          outlined: "",
                                          "hide-details": "",
                                          required: "",
                                          "single-line": "",
                                          dense: "",
                                          maxlength: "100",
                                          readonly: "",
                                        },
                                        model: {
                                          value:
                                            _vm.$v.grant.assignorName.$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.grant.assignorName,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.grant.assignorName.$model",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "px-5" },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(_vm.$t("generals.RUT"))),
                                  ]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c("v-text-field", {
                                            directives: [
                                              {
                                                name: "dni",
                                                rawName: "v-dni",
                                                value: "CL",
                                                expression: "'CL'",
                                              },
                                            ],
                                            attrs: {
                                              error:
                                                _vm.$v.grant.assignorTaxId
                                                  .$error,
                                              outlined: "",
                                              "hide-details": "",
                                              required: "",
                                              "single-line": "",
                                              dense: "",
                                              maxlength: "70",
                                              readonly: "",
                                            },
                                            model: {
                                              value:
                                                _vm.$v.grant.assignorTaxId
                                                  .$model,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.$v.grant.assignorTaxId,
                                                  "$model",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "$v.grant.assignorTaxId.$model",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogGrant = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey-900" },
                      on: { click: _vm.createGrant },
                    },
                    [_vm._v("Ceder documento")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "590",
            persistent: "",
            scrollable: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogLoadingAssign,
            callback: function ($$v) {
              _vm.dialogLoadingAssign = $$v
            },
            expression: "dialogLoadingAssign",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                { staticClass: "px-6 py-6" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2 pb-4", attrs: { align: "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pr-0", attrs: { cols: "2" } },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              indeterminate: "",
                              color: "green-500",
                              width: 8,
                              size: "48",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("v-col", { staticClass: "pl-0" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "d-block body-1 font-weight-bold pt-2 grey-700--text",
                          },
                          [_vm._v("Procesando tu solicitud...")]
                        ),
                        _c(
                          "span",
                          { staticClass: "d-block body-2 mt-1 grey-500--text" },
                          [_vm._v("La cesión del documento se está ejecutando")]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-alert",
                    {
                      staticClass: "rounded-md mt-2",
                      attrs: { color: "green-50", height: 62, dense: "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex pa-0 my-1" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "green-500", size: "22" } },
                            [_vm._v("mdi-information-outline")]
                          ),
                          _c("div", { staticClass: "ml-4" }, [
                            _c(
                              "span",
                              {
                                staticClass: "body-2 grey-900--text",
                                staticStyle: { "line-height": "14px" },
                              },
                              [
                                _vm._v("Este proceso "),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("podría tardar varios minutos")]
                                ),
                                _vm._v(" en completarse. "),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold" },
                                  [
                                    _vm._v(
                                      "El estado se actualizará automáticamente "
                                    ),
                                  ]
                                ),
                                _vm._v(" en el documento. "),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "600",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogDetailAssign,
            callback: function ($$v) {
              _vm.dialogDetailAssign = $$v
            },
            expression: "dialogDetailAssign",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-0" },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "transparent",
                  attrs: { flat: "", height: "46" },
                },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass:
                        "px-5 subtitle-2 grey-500--text font-weight-semibold",
                    },
                    [_vm._v("Información de cesión")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "mr-3",
                          attrs: { align: "center", justify: "center" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                "retain-focus-on-click": "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.dialogDetailAssign = false
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { color: "grey-500", size: "20" } },
                                [_vm._v("mdi-close")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-0 py-4" },
                [
                  _c(
                    "div",
                    { staticClass: "px-5 pb-2" },
                    [
                      _c(
                        "v-list",
                        { staticClass: "v-list-form-main transparent pa-0" },
                        [
                          _c(
                            "v-list-item",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass:
                                    "grey-500--text subtitle-2 font-weight-bold",
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-3",
                                      attrs: {
                                        size: "20",
                                        left: "",
                                        color: "grey-500",
                                      },
                                    },
                                    [_vm._v("mdi-clipboard")]
                                  ),
                                  _vm._v("Estado"),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "body-1" },
                                [
                                  _c("chip-status", {
                                    attrs: {
                                      status:
                                        _vm.instance.assignment_agency_status,
                                      showDetail: true,
                                      isTooltip: false,
                                      type: "assign",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass:
                                    "grey-500--text subtitle-2 font-weight-bold",
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-3",
                                      attrs: {
                                        size: "20",
                                        left: "",
                                        color: "grey-500",
                                      },
                                    },
                                    [_vm._v("mdi-clipboard-search")]
                                  ),
                                  _vm._v("Detalle del estado"),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item-subtitle",
                                {
                                  staticClass: "body-1 align-self-start mt-2",
                                  staticStyle: {
                                    "white-space": "normal !important",
                                  },
                                },
                                [
                                  _vm.instance?.assignment_agency_status_code
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.instance
                                              .assignment_agency_status_code
                                          )
                                        ),
                                      ])
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 text--disabled font-italic d-block",
                                        },
                                        [_vm._v("Sin definir")]
                                      ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item",
                            { staticClass: "pa-0" },
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass:
                                    "grey-500--text subtitle-2 font-weight-bold",
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-3",
                                      attrs: {
                                        size: "20",
                                        left: "",
                                        color: "grey-500",
                                      },
                                    },
                                    [_vm._v("mdi-clipboard-list")]
                                  ),
                                  _vm._v("Track ID"),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "body-1" },
                                [
                                  _vm.instance?.assignment_agency_id
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            color: "grey-background",
                                            right: "",
                                            transition: "scale-transition",
                                            "max-width": "300",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        {
                                                          staticClass:
                                                            "grey-300--text",
                                                          staticStyle: {
                                                            "justify-content":
                                                              "left",
                                                          },
                                                          attrs: {
                                                            text: "",
                                                            ripple: false,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.toClipboard(
                                                                _vm.instance
                                                                  ?.assignment_agency_id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.instance
                                                              ?.assignment_agency_id
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            43912920
                                          ),
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "d-block px-3 py-2",
                                            },
                                            [_vm._v("Copiar")]
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 text--disabled font-italic d-block",
                                        },
                                        [_vm._v("Sin definir")]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-col",
                    { staticClass: "px-6 mb-4" },
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                size: "18",
                                left: "",
                                color: "grey-500",
                              },
                            },
                            [_vm._v("mdi-file-arrow-left-right")]
                          ),
                          _c(
                            "span",
                            { staticClass: "font-weight-bold grey-500--text" },
                            [_vm._v("Cedida a")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mt-3", attrs: { "no-gutters": "" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pa-0 pr-2", attrs: { cols: "4" } },
                            [
                              _c("v-list-item-title", [
                                _vm._v(_vm._s(_vm.$t("generals.RUT"))),
                              ]),
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "dni",
                                    rawName: "v-dni",
                                    value: "CL",
                                    expression: "'CL'",
                                  },
                                ],
                                attrs: {
                                  outlined: "",
                                  "hide-details": "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "32",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.instance.assignee_tax_id,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.instance,
                                      "assignee_tax_id",
                                      $$v
                                    )
                                  },
                                  expression: "instance.assignee_tax_id",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pa-0 pl-2", attrs: { cols: "8" } },
                            [
                              _c("v-list-item-title", [_vm._v("Razón social")]),
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  "hide-details": "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "32",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.instance.assignee_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.instance, "assignee_name", $$v)
                                  },
                                  expression: "instance.assignee_name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mt-3", attrs: { "no-gutters": "" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pa-0 pr-2", attrs: { cols: "4" } },
                            [
                              _c("v-list-item-title", [_vm._v("Email")]),
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  "hide-details": "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "32",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.instance.assignee_email,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.instance,
                                      "assignee_email",
                                      $$v
                                    )
                                  },
                                  expression: "instance.assignee_email",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pa-0 pl-2", attrs: { cols: "8" } },
                            [
                              _c("v-list-item-title", [_vm._v("Dirección")]),
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  "hide-details": "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "32",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.instance.assignee_address,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.instance,
                                      "assignee_address",
                                      $$v
                                    )
                                  },
                                  expression: "instance.assignee_address",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-col",
                    { staticClass: "px-6 mt-2" },
                    [
                      _c(
                        "v-list-item-title",
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                size: "18",
                                left: "",
                                color: "grey-500",
                              },
                            },
                            [_vm._v("mdi-account")]
                          ),
                          _c(
                            "span",
                            { staticClass: "font-weight-bold grey-500--text" },
                            [_vm._v("Cedido por")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mt-3", attrs: { "no-gutters": "" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pa-0 pr-4", attrs: { cols: "4" } },
                            [
                              _c("v-list-item-title", [
                                _vm._v(_vm._s(_vm.$t("generals.RUT"))),
                              ]),
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "dni",
                                    rawName: "v-dni",
                                    value: "CL",
                                    expression: "'CL'",
                                  },
                                ],
                                attrs: {
                                  outlined: "",
                                  "hide-details": "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "32",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.instance.assignor_tax_id,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.instance,
                                      "assignor_tax_id",
                                      $$v
                                    )
                                  },
                                  expression: "instance.assignor_tax_id",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pa-0", attrs: { cols: "4" } },
                            [
                              _c("v-list-item-title", [_vm._v("Nombre")]),
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  "hide-details": "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "32",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.instance.assignor_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.instance, "assignor_name", $$v)
                                  },
                                  expression: "instance.assignor_name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pa-0 pl-4", attrs: { cols: "4" } },
                            [
                              _c("v-list-item-title", [_vm._v("Email")]),
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  "hide-details": "",
                                  required: "",
                                  "single-line": "",
                                  dense: "",
                                  maxlength: "32",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.instance.assignor_email,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.instance,
                                      "assignor_email",
                                      $$v
                                    )
                                  },
                                  expression: "instance.assignor_email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogDetailAssign = false
                        },
                      },
                    },
                    [_vm._v("Cerrar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "792",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogMarkAsAnulled,
            callback: function ($$v) {
              _vm.dialogMarkAsAnulled = $$v
            },
            expression: "dialogMarkAsAnulled",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [_vm._v("Marcar como nulo")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: { click: _vm.closeMarkAsAnulled },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-4 px-5 grey-500--text" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2 pb-4", attrs: { align: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "3" } }, [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/backgrounds/modal-document-null.svg`),
                            width: 148,
                          },
                        }),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pr-4 pl-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "mt-1 mb-3" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  attrs: { color: "grey-700", size: "14" },
                                },
                                [_vm._v("mdi-file-document")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "body-2 font-weight-medium text-uppercase",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("nameDocumentsType")(
                                        (_vm.instance || {}).type || ""
                                      )
                                    ) +
                                      " " +
                                      _vm._s(
                                        _vm._f("nameDocumentsType")(
                                          (_vm.instance || {}).document_type ||
                                            ""
                                        )
                                      ) +
                                      " Nº" +
                                      _vm._s(_vm.instance.number)
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("span", { staticClass: "d-block body-1 pt-2" }, [
                            _vm._v(
                              "Al marcar como nulo un documento, sólo lo estás anulando en la plataforma y no en " +
                                _vm._s(_vm.$t("generals.SII")) +
                                "."
                            ),
                          ]),
                          _c(
                            "span",
                            { staticClass: "d-block body-1 mt-4 mb-3" },
                            [
                              _vm._v("Escribe "),
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("“confirmar”"),
                              ]),
                              _vm._v(" para continuar."),
                            ]
                          ),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              "single-line": "",
                              maxlength: "9",
                              dense: "",
                              "hide-details": "",
                            },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                _vm.confirm.toLowerCase() === "confirmar" &&
                                  _vm.markAsAnulled()
                              },
                            },
                            model: {
                              value: _vm.confirm,
                              callback: function ($$v) {
                                _vm.confirm = $$v
                              },
                              expression: "confirm",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: { click: _vm.closeMarkAsAnulled },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        loading: _vm.loadingAnulled,
                        disabled: _vm.confirm.toLowerCase() !== "confirmar",
                      },
                      on: { click: _vm.markAsAnulled },
                    },
                    [_vm._v("Confirmar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "560",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.createDocumentDialog,
            callback: function ($$v) {
              _vm.createDocumentDialog = $$v
            },
            expression: "createDocumentDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [_vm._v("Crear documento")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: { click: _vm.closeCreateDocumentDialog },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 py-4" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2", attrs: { align: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "4" } }, [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/backgrounds/modal-document-clone.svg`),
                            width: 148,
                          },
                        }),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pr-4 pl-4" },
                        [
                          _c(
                            "v-list",
                            { staticClass: "v-list-form pa-0 transparent" },
                            [
                              _c(
                                "v-list-item",
                                { staticClass: "pa-0 mb-4" },
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        {
                                          staticClass:
                                            "grey-500--text body-1 font-weight-semibold mb-3",
                                          staticStyle: {
                                            "white-space": "normal",
                                            "word-wrap": "break-word",
                                            "line-height": "1.4",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "Crear " +
                                              _vm._s(
                                                (
                                                  (
                                                    _vm.DocumentTypesList.find(
                                                      (d) =>
                                                        d.id === _vm.cloneDoc
                                                    ) || {}
                                                  ).name || ""
                                                ).toLowerCase()
                                              )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-list-item-subtitle",
                                        { staticClass: "mt-1 mb-3" },
                                        [
                                          _c(
                                            "v-radio-group",
                                            {
                                              staticClass: "ma-0",
                                              attrs: {
                                                column: "",
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value: _vm.actionCreateDoc,
                                                callback: function ($$v) {
                                                  _vm.actionCreateDoc = $$v
                                                },
                                                expression: "actionCreateDoc",
                                              },
                                            },
                                            [
                                              _c("v-radio", {
                                                staticClass: "mb-2",
                                                attrs: {
                                                  label:
                                                    "Anula documento de referencia",
                                                  value: "1",
                                                },
                                              }),
                                              _c("v-radio", {
                                                staticClass: "mb-2",
                                                attrs: {
                                                  label:
                                                    "Corrige texto documento de referencia",
                                                  value: "2",
                                                },
                                              }),
                                              _c("v-radio", {
                                                attrs: {
                                                  label: "Corrige montos",
                                                  value: "3",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    { staticClass: "mt-n1 d-block grey-700--text body-1" },
                    [_vm._v("Descripción del documento")]
                  ),
                  _c(
                    "v-list-item",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                              maxlength: "90",
                            },
                            model: {
                              value: _vm.noteReason,
                              callback: function ($$v) {
                                _vm.noteReason = $$v
                              },
                              expression: "noteReason",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", ripple: false },
                      on: { click: _vm.closeCreateDocumentDialog },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        disabled: !_vm.actionCreateDoc || !_vm.noteReason,
                        ripple: false,
                      },
                      on: { click: _vm.createNoteDocument },
                    },
                    [_vm._v(" Crear documento ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "790",
            persistent: "",
            scrollable: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogSunat,
            callback: function ($$v) {
              _vm.dialogSunat = $$v
            },
            expression: "dialogSunat",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [_vm._v("Detalle del estado")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogSunat = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 pt-6 pb-0" },
                _vm._l(
                  _vm.instance.agency_status_detail_list,
                  function (detail, i) {
                    return _c(
                      "div",
                      { key: i },
                      [
                        _c("span", { staticClass: "d-block mb-8" }, [
                          _vm._v(_vm._s(detail)),
                        ]),
                        i !== _vm.instance.agency_status_detail_list.length - 1
                          ? _c(
                              "v-sheet",
                              {
                                staticClass: "text-left ml-1 mt-n8 mb-3",
                                attrs: { height: "10" },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mt-1",
                                    staticStyle: {
                                      position: "absolute",
                                      left: "22.5px",
                                    },
                                    attrs: { size: "3", color: "placeholder" },
                                  },
                                  [_vm._v("mdi-circle")]
                                ),
                                _c("v-divider", {
                                  staticClass: "my-0",
                                  attrs: { vertical: "" },
                                }),
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mb-n1",
                                    staticStyle: { left: "-0.4px", top: "7px" },
                                    attrs: { size: "3", color: "placeholder" },
                                  },
                                  [_vm._v("mdi-circle")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }
                ),
                0
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey-900", ripple: false },
                      on: {
                        click: function ($event) {
                          _vm.dialogSunat = false
                        },
                      },
                    },
                    [_vm._v("Aceptar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "792",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogReprocessDoc,
            callback: function ($$v) {
              _vm.dialogReprocessDoc = $$v
            },
            expression: "dialogReprocessDoc",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [_vm._v("Re-procesar documento")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: { click: _vm.closeReprocessDoc },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-4 px-5 grey-500--text" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2 pb-4", attrs: { align: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "3" } }, [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/backgrounds/modal-document-null.svg`),
                            width: 148,
                          },
                        }),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pr-4 pl-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "mt-1 mb-3" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  attrs: { color: "grey-700", size: "14" },
                                },
                                [_vm._v("mdi-file-document")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "body-2 font-weight-medium text-uppercase",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("nameDocumentsType")(
                                        (_vm.instance || {}).type || ""
                                      )
                                    ) +
                                      " " +
                                      _vm._s(
                                        _vm._f("nameDocumentsType")(
                                          (_vm.instance || {}).document_type ||
                                            ""
                                        )
                                      ) +
                                      " Nº" +
                                      _vm._s(_vm.instance.number)
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("span", { staticClass: "d-block body-1 pt-2" }, [
                            _vm._v(
                              "Al confirmar, se enviará nuevamente este documento a la " +
                                _vm._s(_vm.$t("generals.SII")) +
                                " para su revisión y aceptación. Esta acción no se puede deshacer."
                            ),
                          ]),
                          _c(
                            "span",
                            { staticClass: "d-block body-1 mt-4 mb-3" },
                            [
                              _vm._v("Escribe "),
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("“confirmar”"),
                              ]),
                              _vm._v(" para continuar."),
                            ]
                          ),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              "single-line": "",
                              maxlength: "9",
                              dense: "",
                              "hide-details": "",
                            },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                _vm.confirm.toLowerCase() === "confirmar" &&
                                  _vm.reprocessDoc()
                              },
                            },
                            model: {
                              value: _vm.confirm,
                              callback: function ($$v) {
                                _vm.confirm = $$v
                              },
                              expression: "confirm",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: { click: _vm.closeReprocessDoc },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        loading: _vm.loadingReprocessDoc,
                        disabled: _vm.confirm.toLowerCase() !== "confirmar",
                      },
                      on: { click: _vm.reprocessDoc },
                    },
                    [_vm._v("Confirmar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            scrollable: true,
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.modalPDF,
            callback: function ($$v) {
              _vm.modalPDF = $$v
            },
            expression: "modalPDF",
          },
        },
        [
          _c("render-pdf", {
            attrs: {
              basicRender: true,
              documentType: _vm._f("nameDocumentsType")(
                (_vm.instance || {}).type || ""
              ),
              number: _vm.instance.number,
              loaderRender: _vm.loaderRender,
              renderUrl: _vm.renderUrl,
              flat: true,
              formatPDF: _vm.formatPDF,
              showFormat: true,
              templates: _vm.pdfTemplates,
              selectedTemplate: _vm.selectedTemplate,
              showTemplateSelector: true,
            },
            on: {
              close: function ($event) {
                _vm.modalPDF = false
              },
              "update:formatPDF": function ($event) {
                _vm.formatPDF = $event
              },
              "update:format-p-d-f": function ($event) {
                _vm.formatPDF = $event
              },
              "update:selectedTemplate": function ($event) {
                _vm.selectedTemplate = $event
              },
              "update:selected-template": function ($event) {
                _vm.selectedTemplate = $event
              },
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.modalEmail,
            callback: function ($$v) {
              _vm.modalEmail = $$v
            },
            expression: "modalEmail",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Enviar por mail")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.modalEmail = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 py-4" },
                [
                  _c("v-list", { staticClass: "v-list-form pa-0 transparent" }),
                  _c(
                    "div",
                    { staticClass: "d-flex align-center" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "grey-500--text body-1",
                          staticStyle: { "min-width": "60px" },
                        },
                        [_vm._v("Para")]
                      ),
                      _c("v-combobox", {
                        key: _vm.key,
                        ref: "email",
                        staticClass: "a-combobox",
                        attrs: {
                          "hide-details": "",
                          items: _vm.emailsList,
                          outlined: "",
                          required: "",
                          "hide-selected": "",
                          placeholder: !_vm.messages.recipient.length
                            ? "Escribe el email del destinatario"
                            : "",
                          multiple: "",
                          "deletable-chips": "",
                          "small-chips": "",
                          dense: "",
                          "single-line": "",
                          autocomplete: "off",
                        },
                        on: { "update:search-input": _vm.setEmail },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function (data) {
                              return [
                                _c(
                                  "v-chip",
                                  _vm._b(
                                    {
                                      staticClass: "pr-2 ma-1 close-chip",
                                      attrs: {
                                        color: "green-100",
                                        "input-value": data.selected,
                                        close: "",
                                        small: "",
                                      },
                                      on: {
                                        click: data.select,
                                        "click:close": function ($event) {
                                          return _vm.remove(data.item)
                                        },
                                      },
                                    },
                                    "v-chip",
                                    data.attrs,
                                    false
                                  ),
                                  [_vm._v(_vm._s(data.item))]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item",
                            fn: function (data) {
                              return [
                                _c(
                                  "v-list-item-avatar",
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "grey-700" } },
                                      [_vm._v("mdi-account-circle")]
                                    ),
                                  ],
                                  1
                                ),
                                _c("v-list-item-title", {
                                  staticClass: "ml-n2 font-weight-medium",
                                  domProps: { innerHTML: _vm._s(data.item) },
                                }),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.messages.recipient,
                          callback: function ($$v) {
                            _vm.$set(_vm.messages, "recipient", $$v)
                          },
                          expression: "messages.recipient",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.modalEmail = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.$store.state.messages.createLoader,
                        color: "grey-900",
                      },
                      on: { click: _vm.createMessages },
                    },
                    [_vm._v("Enviar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }